export default {
  zh: {
    rule: "规则",
    acd: "活动倒计时",
    rank: "排行榜",
    reward: "奖励",
    ruleC: `
    1，活动时间：沙特时间每个月1号到下个月1号00:00<br/>
    2，除了特殊奖励，所有奖励会自动发放<br/>
    3，家族排名按照活动期间家族经验值排名<br/>
    4，前10名支持者按照贡献的家族荣誉值排名
    `,
    t1: "家族族长",
    t2: "前三名支持者",
    t3: "前十名支持者",
    tips:"The new event is in the pipeline and is expected to be launched in August.",
  },
  en: {
    rule: "Rules",
    acd: "Activity CountDown",
    rank: "Ranking",
    reward: "Reward",
    ruleC: `
     1. Activity time: Saudi time from the 1st of each month to the 1st of the next month at 00:00<br/>
     2. Except special rewards, all rewards will be issued automatically<br/>
     3. The family ranking is ranked according to the family experience value during the event<br/>
     4. The top 10 supporters are ranked according to the family honor value they contributed
    `,
    t1: "Family Patriarch",
    t2: "Top three supporters",
    t3: "Top ten supporters",
    tips:"The new event is in the pipeline and is expected to be launched in August.",
  },
  ar: {
    rank: 'الترتيب',
    reward: 'مكافأة',
    rule: 'القواعد',
    acd: "نشط العد التنازلي",
    ruleC: `
    1. وقت النشاط: 00:00 من اليوم الأول من كل شهر إلى الأول من الشهر التالي (بتوقيت السعودية) <br/>
    2. باستثناء المكافآت الخاصة ، سيتم إرسال جميع المكافآت تلقائيًا <br/>
    3. يتم ترتيب القبائل وفقًا لنقاط خبرة القبيلة خلال الحدث <br/>
    4. يتم ترتيب افضل 10 داعمين وفقا للقيمة التي ساهموا بها في القبيلة 
    `,
    t1: "زعيم القبيلة",
    t2: "أفضل ثلاثة داعمين",
    t3: "أفضل 10 داعمين",
    tips:"الحدث الجديد في طور الإعداد ومن المتوقع إطلاقه في أغسطس.",
  },
  tr: {
    rule: "Kurallar",
    acd: "Etkinlik Geri Sayımı",
    rank: "Sıralama",
    reward: "Ödül",
    ruleC: `
    1.Etkinlik Zamanı: Türkiye saati ile her ayın 1'i ile bir sonraki ayın 1'i arasındadır. 00:00 <br/>
    2. Özel ödüller hariç tüm ödüller otomatik olarak verilecektir.<br/>
    3. Klan Sıralaması, Yapmış olduğunuz atışın miktarına göre sıralanır<br/>
    4. İlk 10 destekçi, katkıda bulundukları Klan onur değerine göre sıralanır.<br/>
    `,
    t1: "Klan Sahibi",
    t2: "İlk 3 Destekçi",
    t3: "İlk 10 Destekçi",
    tips:"Yeni Seviye Sistemi Tasarım Aşamasında ve Ağustos Ayında Başlatılacaktır.",
  },
  pt:{
    rule: "Regras",
    acd: "Contagem Regressiva da Atividade",
    rank: "Classificação",
    reward: "Recompensa",
    ruleC: `
     1. Horário da atividade: horário da Arábia Saudita, do dia 1 de cada mês até o dia 1 do mês seguinte às 00:00<br/>
     2. Exceto recompensas especiais, todas as recompensas serão emitidas automaticamente<br/>
     3. O ranking da família é classificado de acordo com o valor de experiência da família durante o evento<br/>
     4. Os 10 melhores apoiadores são classificados de acordo com o valor de honra da família que contribuíram
    `,
    t1: "Patriarca da Família",
    t2: "Top três apoiadores",
    t3: "Top dez apoiadores",
    tips: "O novo evento está em andamento e deve ser lançado em agosto."
},
    id:{
    rule: "Aturan",
    acd: "Hitung Mundur Aktivitas",
    rank: "Peringkat",
    reward: "Hadiah",
    ruleC: `
     1. Waktu aktivitas: Waktu Arab Saudi dari tanggal 1 setiap bulan hingga tanggal 1 bulan berikutnya pukul 00:00<br/>
     2. Kecuali hadiah khusus, semua hadiah akan diberikan secara otomatis<br/>
     3. Peringkat keluarga diurutkan berdasarkan nilai pengalaman keluarga selama acara<br/>
     4. 10 pendukung teratas diurutkan berdasarkan nilai kehormatan keluarga yang mereka kontribusikan
    `,
    t1: "Patriark Keluarga",
    t2: "Tiga Pendukung Teratas",
    t3: "Sepuluh Pendukung Teratas",
    tips: "Acara baru sedang dipersiapkan dan diperkirakan akan diluncurkan pada bulan Agustus."
},
    uz:{
    rule: "Qoidalar",
    acd: "Faoliyatning kamayishi",
    rank: "Reyting",
    reward: "Mukofot",
    ruleC: `
     1. Faoliyat vaqti: har oyning 1-kuni soat 00:00 dan keyingi oyning 1-kunigacha (Saudiya vaqti)<br/>
     2. Maxsus mukofotlar tashqari, barcha mukofotlar avtomatik ravishda taqdim etiladi<br/>
     3. Oila reytingi faoliyat davomida oila tajriba qiymatiga qarab baholanadi<br/>
     4. Eng yaxshi 10 qo'llab-quvvatlovchilar o'zlarining oilaviy sharaf qiymatiga qarab reytinglanadi
    `,
    t1: "Oila Boshlig'i",
    t2: "Eng yaxshi uch qo'llab-quvvatlovchi",
    t3: "Eng yaxshi o'n qo'llab-quvvatlovchi",
    tips: "Yangi tadbir tayyorlanmoqda va avgust oyida boshlanishi kutilmoqda."
},
    ru:{
    rule: "Правила",
    acd: "Обратный отсчет мероприятия",
    rank: "Рейтинг",
    reward: "Награда",
    ruleC: `
     1. Время мероприятия: с 1-го числа каждого месяца до 1-го числа следующего месяца в 00:00 (время Саудовской Аравии)<br/>
     2. Кроме специальных наград, все награды будут выдаваться автоматически<br/>
     3. Рейтинг семей определяется по значению опыта семьи в ходе мероприятия<br/>
     4. Топ-10 поддерживающих ранжируются по значению чести, которое они внесли в семью
    `,
    t1: "Глава семьи",
    t2: "Три лучших поддерживающих",
    t3: "Десять лучших поддерживающих",
    tips: "Новое мероприятие готовится к запуску и ожидается в августе."
},
    fa:{
    rule: "قوانین",
    acd: "شمارش معکوس فعالیت",
    rank: "رتبه‌بندی",
    reward: "جایزه",
    ruleC: `
     1. زمان فعالیت: از 1ام هر ماه تا 1ام ماه بعد ساعت 00:00 (زمان عربستان سعودی)<br/>
     2. به جز جوایز ویژه، همه جوایز به صورت خودکار اهدا می‌شوند<br/>
     3. رتبه‌بندی خانواده بر اساس ارزش تجربه خانواده در طول رویداد است<br/>
     4. 10 نفر برتر حامیان بر اساس ارزش افتخار خانواده‌ای که به آن‌ها کمک کرده‌اند، رتبه‌بندی می‌شوند
    `,
    t1: "رئیس خانواده",
    t2: "سه حامی برتر",
    t3: "ده حامی برتر",
    tips: "رویداد جدید در حال آماده‌سازی است و انتظار می‌رود در ماه اوت راه‌اندازی شود."
}





}


// WEBPACK FOOTER //
// src/pages/activity/family/lang.js